import type { AffiliateOverride } from '../../../types/LegacyEventData';
import type { ProductOverride } from '../../../types/Product';
import type { Deal } from '../../types/Deal';
import type { DealData } from '../../types/DealData';

export enum WidgetResult {
  SKIPPED = 'skipped' /* skipped due to business logic */,
  MISSING = 'missing' /* no offers returned */,
  PRESERVED = 'preserved' /* API request fails, preserve server HTML */,
  SUCCESS = 'success' /* everything else */,
}

export interface IAnalyticsMethods {
  sendAnalytics: ({
    affiliate,
    category,
    deal,
    product,
    products,
    dealData,
  }: {
    affiliate: AffiliateOverride;
    category?: string;
    deal?: Deal;
    product?: ProductOverride;
    products?: ProductOverride[];
    dealData?: DealData;
  }) => void;
}
